// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination-footer {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    padding: 10px;\n    background-color: #f5f5f5;\n    border-top: 1px solid #ddd;\n    display: flex;\n    justify-content: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
